export default {
  translation_agencies: {},
}